<div *ngIf="adToDisplay == 0" style="background-color: black; width: 480px;border-radius: 5px;padding: 4px" fxLayout="row" fxLayoutAlign="center center">
<a href="https://sovrn.co/ukjwbtv" target="new">
<img src="https://cdn11.bigcommerce.com/s-ms459ombhg/images/stencil/250x100/bushnellgolf_logo_rgb_fc_white_1541671551__04064.original.png">
</a>
</div>

<div *ngIf="adToDisplay == 1" style="background-color: white; width: 480px;border-radius: 5px;padding: 4px" fxLayout="row" fxLayoutAlign="center center">
  <a href="https://sovrn.co/9xhfu30" target="new">
  <img src="https://cdn11.bigcommerce.com/s-53287/images/stencil/360x120/400x120logophone_1498864871__08855.original.jpg">
  </a>
</div>
  
<div *ngIf="adToDisplay == 2" style="background-color: white; width: 480px;border-radius: 5px;padding: 4px" fxLayout="row" fxLayoutAlign="center center">
  <a href="https://sovrn.co/1jv19wf" target="new">
  <img src="https://cdn.shopify.com/s/files/1/0267/2646/5578/t/90/assets/sunday-logo_150x.png?v=112693383516621317011659666438">
  </a>
</div>
  
<div *ngIf="adToDisplay == 4" style="background-color: black; width: 480px;border-radius: 5px;padding: 4px" fxLayout="row" fxLayoutAlign="center center">
  <a href="https://www.digistore24.com/redir/372937/jfbertrand/" target="new">
  <img src="/assets/images/bitcoin2021.png">
  </a>
</div>

  
<div *ngIf="adToDisplay == 5" style="background-color: white; width: 480px;border-radius: 5px;padding: 4px" fxLayout="row" fxLayoutAlign="center center">
  <a href="https://go.mypartner.io/business-financing/?ref=0014x00001Qa0kVAAR" target="new">
  <img src="/assets/images/seitramslending.png">
  </a>
</div>
  

